import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Signup() {
  const { signup } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be at least 6 characters."); return; }
    setLoading(true);
    try {
      await signup(name, email, password);
      toast.success("Welcome to the atelier.");
      navigate("/account");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Signup failed.");
    } finally { setLoading(false); }
  };

  return (
    <main className="min-h-screen grid md:grid-cols-2" data-testid="signup-page">
      <div className="hidden md:block">
        <img src="https://images.pexels.com/photos/17040892/pexels-photo-17040892.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1400&w=900" alt="" className="w-full h-full object-cover" />
      </div>
      <div className="flex flex-col justify-center px-6 md:px-16 py-16">
        <Link to="/" className="font-serif text-xl tracking-[0.3em] text-[#1A1A1A] mb-16">DABKAZARI</Link>
        <p className="text-[11px] uppercase tracking-nav text-[#5C1A1B]">Create account</p>
        <h1 className="font-serif text-4xl md:text-5xl mt-3">Begin your archive.</h1>

        <form onSubmit={submit} className="mt-10 space-y-5">
          <label className="block">
            <span className="text-[11px] uppercase tracking-nav text-[#7A7A7A]">Full name</span>
            <input value={name} onChange={(e) => setName(e.target.value)} required className="input-underline" data-testid="signup-name" />
          </label>
          <label className="block">
            <span className="text-[11px] uppercase tracking-nav text-[#7A7A7A]">Email</span>
            <input value={email} onChange={(e) => setEmail(e.target.value)} type="email" required className="input-underline" data-testid="signup-email" />
          </label>
          <label className="block">
            <span className="text-[11px] uppercase tracking-nav text-[#7A7A7A]">Password</span>
            <input value={password} onChange={(e) => setPassword(e.target.value)} type="password" required className="input-underline" data-testid="signup-password" />
          </label>
          <button className="btn-editorial w-full" disabled={loading} data-testid="signup-submit">
            {loading ? "Creating…" : "Create account"}
          </button>
        </form>
        <p className="mt-6 text-sm text-[#4A4A4A]">
          Already have an account? <Link to="/login" className="underline underline-offset-4 hover:text-[#5C1A1B]" data-testid="signup-login-link">Sign in</Link>
        </p>
      </div>
    </main>
  );
}
